import {event} from '../modules/event';
import HTMLPlayer from '../modules/HTMLPlayer2';
import AdvPlayer from '../modules/AdvPlayer2';
import {scriptonload} from '../modules/scriptonload';


var CombinedPlayer =  class {
	constructor(wrapper) {
		this._createElements(wrapper);
        this._getDataApi();
		this._addEvents();

	}

	_createElements(wrapper){
		this.wrapper = wrapper;
        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.dataApi = undefined,
        this.btn = this.wrapper.querySelector('[data-CombinedPlayer-btn]');
		this.insert = this.wrapper.querySelector('[data-CombinedPlayer-insert]');
        this.isMobileAgent = this._defineUserAgent();
        this.advBreak = 12; //рекламу показываем каждые 12 часов
        this.isAdvCookie = this._defineAdvCookie();
        this.oAdvPlayer;
        this.oHTMLPlayer;
        this.oYoutubePlayer;
	}

    _defineUserAgent(){
        var agentAll = ['ipod','iphone','ipad', 'android', 'blackberry'],
            i = 0;

        for(i;i< agentAll.length;i++){
            var re = new RegExp(agentAll[i], 'i');
            if( re.test( navigator.userAgent ) ) return agentAll[i];
        }
        return false;
    }

    _defineAdvCookie(){
        var curTime = new Date().getTime()

        if (!localStorage || !localStorage.isKinoafishaVideoAdv || ((curTime - parseFloat(localStorage.isKinoafishaVideoAdv))/1000/60/60 < this.advBreak)){
            localStorage.isKinoafishaVideoAdv = curTime;
            return false;
        }
        return true;
    }

    _getDataApi(){
        var self = this,
            path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafisha.info',
            _onSuccess = function(dataApi){
                self.dataApi = dataApi;
            },
            _onerror = function(){};
        GLOBALS.scriptRequest('http://api.'+ path +'/player/info/' + this.data.trailer_id + '/', function(dataApi){_onSuccess(dataApi)}, function(){_onError()});
    }

	_addEvents(){
        var self = this;

        event.add(this.btn, 'click', function(e){
            e.preventDefault();

            if(self.isAdvCookie || self.isMobileAgent) { /* на мобильниках реклама не будет показываться, нужно плееры загружать заранее */
                if (self.data.youtube) self._createYoutubePlayer.call(self);
                else self._createHTMLPlayer.call(self);
            }
            else {
                localStorage.isKinoafishaVideoAdv = 'ok';
                self._createAdvPlayer.call(self);
            }

            if(self.wrapper.className.indexOf('js-active') === -1) self.wrapper.className = self.wrapper.className + ' js-active';

        });
	}

    _createYoutubePlayer(){
        var self = this,
            player,
            onPlayerReady = function(event){
               event.target.playVideo();

            },
            onPlayerStateChange = function(event){
                if(event.data === 0) del();
            },
            del = function(){
                self.wrapper.className = self.wrapper.className.replace(' js-active', '');
                self.oYoutubePlayer.destroy();
                delete self.oYoutubePlayer;
                self.insert.innerHTML = '';
            },
            checkLoading = function (){
                if(window.isYouTubeIframeAPIReady) addApi();
                else{
                    setTimeout(function(){
                        checkLoading();
                    }, 200);
                }
            },
            addApi = function(){
                self.oYoutubePlayer = new YT.Player(self.insert.firstChild, {
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            };

        this.insert.innerHTML = '<iframe id="qwe" class="combinedPlayer_youtube" src="'+ this.data.youtube +'?enablejsapi=1" allowfullscreen="" frameborder="0"></iframe>';

        if(!window.onYouTubeIframeAPIReady){
            window.onYouTubeIframeAPIReady = function(){
                window.isYouTubeIframeAPIReady = true;
            }
            scriptonload(['https://www.youtube.com/iframe_api']);
        }

        checkLoading();
    }

    _createAdvPlayer(){
        var self = this;

        this.oAdvPlayer = new AdvPlayer(this.wrapper, this.insert);

        this.oAdvPlayer.afterEnd = function(){
            self.oAdvPlayer.del();
            delete self.oAdvPlayer;
            if (self.data.youtube) self._createYoutubePlayer.call(self);
            else self._createHTMLPlayer.call(self);
        }
        this.oAdvPlayer.afterSkip = function(){
            self.oAdvPlayer.del();
            delete self.oAdvPlayer;
            if (self.data.youtube) self._createYoutubePlayer.call(self);
            else self._createHTMLPlayer.call(self);
        }
        this.oAdvPlayer.afterClicking = function(){
            self.wrapper.className = self.wrapper.className.replace(' js-active', '');
            self.oAdvPlayer.del();
            delete self.oAdvPlayer;
        }

        this.oAdvPlayer.initialize();
        this.oAdvPlayer.show();
    }

    _createHTMLPlayer(){
        var self = this,
            checkDataApi = function (){
                if(self.dataApi) create();
                else{
                    setTimeout(function(){
                        checkDataApi();
                    }, 200);
                }
            },
            create = function(){
                self.oHTMLPlayer = new HTMLPlayer(self.wrapper, self.insert, self.dataApi);
                self.oHTMLPlayer.afterEnd = function(){
                    self.wrapper.className = self.wrapper.className.replace(' js-active', '');
                    self.oHTMLPlayer.del();
                    delete self.oHTMLPlayer;
                }
            };

        //
        checkDataApi();
    }

    del(){
        if(this.oAdvPlayer) this.oAdvPlayer.del();
        if(this.oHTMLPlayer) this.oHTMLPlayer.del();
        if(this.oYoutubePlayer) this.oYoutubePlayer.del();
    }
};

export {CombinedPlayer};





































